<template>
  <div>
    <QS-h4-title title="收款基础信息" />
    <el-form label-width="130px" label-position="right">
      <column-box
        :source="source"
        :list="list"
        :column="3"
        :label-width="130"
      >
        <el-form-item
          :label="'付款凭证' + columnSeparator"
          class="collection"
        >
          <show-img-and-file :list="source.photo" />
        </el-form-item>
      </column-box>
    </el-form>
  </div>
</template>

<script>
import selectOption from '@/store/dict/selectOptionDict'

export default {
  props: {
    source: {
      type: Object,
      default: () => ({}),
    },
  },
  watch: {
    source: {
      handler(val) {
        // eslint-disable-next-line vue/no-mutating-props
        this.source.stateName = selectOption.collectionStateList[val.state]
        // eslint-disable-next-line vue/no-mutating-props
        this.source.customerTypeName = selectOption.customerTypeDict[val.customerType]
      },
      deep: true,
    },
  },
  data() {
    return {
      list: [
        {
          key: 'id',
          name: '收款单ID',
        },
        {
          key: 'stateName',
          name: '收款单状态',
        },
        {
          key: 'gmtCreate',
          name: '创建时间',
        },
        {
          key: 'completeTime',
          name: '完成时间',
        },
        {
          key: 'discardTime',
          name: '作废时间',
        },
        {
          key: 'commissionAmount',
          name: '乾三佣金',
        },
        {
          key: 'amount',
          name: '收款金额',
        },
        {
          key: 'tenantAmount',
          name: '到账金额',
        },
        {
          key: 'payFee',
          name: '支付手续费',
        },
        {
          key: 'feePayerDesc',
          name: '支付手续费承担方',
        },
        {
          key: 'batchReceivableId',
          name: '批量收款ID',
        },
        {
          key: 'customerTypeName',
          name: '付款方类型',
        },
        {
          key: 'customer',
          name: '付款方',
        },
        {
          key: 'remarks',
          name: '备注',
        },
        {
          key: 'discardReason',
          name: '作废原因备注',
        },
      ],
      itemIndex: -1,
    }
  },
  created() {
    // eslint-disable-next-line vue/no-mutating-props
    this.source.stateName = selectOption.collectionStateList[this.source.state]
    // eslint-disable-next-line vue/no-mutating-props
    this.source.customerTypeName = selectOption.customerTypeDict[this.source.customerType]
  },
  methods: {
    // eslint-disable-next-line vue/no-unused-properties
    moveIn(index) {
      this.itemIndex = index
    },
    // eslint-disable-next-line vue/no-unused-properties
    moveOut() {
      this.itemIndex = -1
    },
  },
}
</script>

<style lang="scss" scoped>
.file_item{
  width: 100%;
  color: #276BEC;
  cursor: pointer;
  overflow:hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}
img {
  width: 80px;
  height: 80px;
  border-radius: 4px;
  overflow: hidden;
}
.collection{
  ::v-deep .el-form-item__content {
    margin-left: 0px !important;
  }
  ::v-deep .el-form-item__label {
    min-width: 130px;
  }
}
.imgs{
  display: flex;
  .imgList{
    width: 80px;
    height: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    border-radius: 4px;
    position: relative;
    margin-right: 10px;
    .downloadImg {
      position: absolute;
      right: 0;
      bottom: 0;
      background: white;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      z-index: 10;
      font-weight: 700;
    }
  }
}

</style>
